import React, { useState } from 'react';
import { I18n } from 'aws-amplify/utils';
import { AuthTheme, SignUpConfig } from './auth-theme';
import { Toast } from './auth-ui';
import { authErrorMessage } from './auth-errors';
import CustomSignIn from './signin-helper';
import CustomSignUp from './signup-helper';
import CustomForgotPassword from './forgotpassword-helper';
import ConfirmSignUp from './confirm-signup-helper';

// Replaces aws-amplify-react's <Authenticator>, which was a v3-only package.
// It rendered whichever child's `_validAuthStates` matched the current state and
// carried a lot of machinery this app never used: federated providers, the
// Greetings bar, MFA/TOTP setup, contact verification, hub-event routing. What
// is left is the four screens the app actually reaches.
const AUTH_STATES = ['signIn', 'signUp', 'confirmSignUp', 'forgotPassword'];

function Authenticator({ login }) {
  const [authState, setAuthState] = useState('signIn');
  const [authData, setAuthData] = useState({});
  const [error, setError] = useState(null);

  const changeState = (state, data = {}) => {
    if (!AUTH_STATES.includes(state)) {
      throw new Error(`Unknown auth state: ${state}`);
    }
    setError(null);
    setAuthData(data);
    setAuthState(state);
  };

  const shared = {
    theme: AuthTheme,
    authData,
    changeState,
    onError: (err) => setError(authErrorMessage(err)),
  };

  return (
    <div style={AuthTheme.container}>
      {authState === 'signIn' && <CustomSignIn {...shared} login={login} />}
      {authState === 'signUp' && (
        <CustomSignUp {...shared} signUpConfig={SignUpConfig} />
      )}
      {authState === 'confirmSignUp' && <ConfirmSignUp {...shared} />}
      {authState === 'forgotPassword' && <CustomForgotPassword {...shared} />}
      {error && (
        <Toast theme={AuthTheme} onClose={() => setError(null)}>
          {I18n.get(error)}
        </Toast>
      )}
    </div>
  );
}

export default Authenticator;
